import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-filter-loader',
  templateUrl: './filter-loader.component.html',
  styleUrls: ['./filter-loader.component.scss']
})
export class FilterLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
